import { filterItrationsAccordingToDateRange } from 'views/root/views/home/views/dashboard/util';
import { GRANULARITY } from '../../consts';
import { getGranularityAccordingToDatesAndChoice } from './granularity';

export const getSearchRangesFromFilters = ({
  orderedIterations,
  filters,
  forSearch = true,
  workingDaysSetting
}) => {
  const { rollupDateRanges } = getGranularityAccordingToDatesAndChoice(
    filters?.selectedTimeRanges?.start_date,
    filters?.selectedTimeRanges?.end_date,
    filters.selectedGranularity,
    undefined,
    workingDaysSetting
  );
  return filters?.selectedGranularity === GRANULARITY.ITERATIONS
    ? filterItrationsAccordingToDateRange(
        filters?.selectedTimeRanges?.start_date,
        filters?.selectedTimeRanges?.end_date,
        orderedIterations
      )
    : forSearch
    ? [
        {
          before: filters?.selectedTimeRanges?.end_date,
          after: filters?.selectedTimeRanges?.start_date
        }
      ]
    : rollupDateRanges;
};
